import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { SignOut, SquaresFour, UserCircle, Wrench } from "@phosphor-icons/react";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashPath = user?.role === "admin" ? "/admin" : user?.role === "professionista" ? "/pro" : "/dashboard";

  return (
    <header className="sticky top-0 z-50 glass-nav border-b border-border/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img src="/nexa-mark.png" alt="NEXA" className="w-9 h-9 rounded-xl object-contain" />
          <span className="font-heading text-xl font-bold tracking-tight">NEXA</span>
        </Link>

        <nav className="flex items-center gap-2">
          {!user && (
            <>
              <Button variant="ghost" onClick={() => navigate("/search")} data-testid="nav-explore-btn">
                Esplora
              </Button>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Accedi
              </Button>
              <Button className="rounded-full" onClick={() => navigate("/register")} data-testid="nav-register-btn">
                Registrati
              </Button>
            </>
          )}
          {user && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-2 rounded-full pl-1 pr-3 py-1 hover:bg-secondary transition-colors" data-testid="nav-user-menu">
                  <Avatar className="w-8 h-8">
                    <AvatarImage src={user.picture} />
                    <AvatarFallback className="bg-primary text-primary-foreground text-xs">
                      {user.name?.[0]?.toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <span className="text-sm font-medium hidden sm:block">{user.name?.split(" ")[0]}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52">
                <div className="px-2 py-1.5 text-xs text-muted-foreground">{user.email}</div>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate(dashPath)} data-testid="nav-dashboard-link">
                  {user.role === "admin" ? <SquaresFour className="mr-2" /> : user.role === "professionista" ? <Wrench className="mr-2" /> : <UserCircle className="mr-2" />}
                  {user.role === "admin" ? "Pannello Admin" : user.role === "professionista" ? "Dashboard Pro" : "Le mie prenotazioni"}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/search")}>Esplora servizi</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout-btn" className="text-destructive">
                  <SignOut className="mr-2" /> Esci
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
